export default {
  route: {
    dashboard: '首页',
    warningManagement: '预警管理',
    overview: '概览',
    systemDashboard: '系统概览',
    todayOverview: '今日概览',
    mineOverview: '我的概览',
    shareOverview: '分享概览',
    overviewDetail: '概览详情',
    bookmarkList: '书签列表',
    analysis: '分析',
    overallAnalysis: '整体分析',
    eventAnalysis: '事件分析',
    ltVAnalysis: 'LTV 分析',
    pageAnalysis: '页面分析',
    pageDetail: '页面详情',
    userBehavior: '行为轨迹',
    channelAnalysis: '渠道分析',
    funnelAnalysis: '漏斗分析',
    retainedAnalysis: '留存分析',
    intervalAnalysis: '间隔分析',
    userPath: '用户路径',
    distributionAnalysis: '分布分析',
    landingAnalysis: '落地页分析',
    customIndicator: '自定义指标',
    attributionAnalysis: '归因分析',
    sessionAnalysis: 'Session分析',
    operatingIndicator: '操作指标',
    group: '分群',
    userGroup: '用户分群',
    userList: '用户列表',
    channel: '渠道',
    channelActivity: '渠道活动',
    channelLink: '渠道链接',
    channelPromote: '推广渠道',
    channelRule: '渠道规则',
    shortChainDetail: '短链详情',
    buriedPoint: '埋点',
    aliyunLogQuery: '日志查询',
    ckLogQuery: '日志查询',
    eventGroup: '事件分组',
    eventRecycle: '事件回收',
    customEvent: '自定事件',
    newCustomEvent: '新建事件',
    editCustomEvent: '编辑事件',
    customEventDetail: '事件详情',
    virtualEvent: '虚拟事件',
    metaEvent: '元事件',
    metadata: '元数据',
    setting: '设置',
    projectList: '项目列表',
    appList: '应用列表',
    personList: '人员列表',
    roleManagement: '角色管理',
    tenantInformation: '租户信息',
    developConfiguration: '开发配置',
    accountSetting: '帐号设置',
    system: '系统',
    tenantManagement: '租户管理',
    accessMenu: '权限菜单',
    userManagement: '用户管理',
    projectManagement: '项目管理',
    appManagement: '应用管理',
    channelManagement: '渠道管理',
    userDetail: '用户详情',
    analyseUserList: '用户详情',
    appApply: '应用申请',
    pageAttribute: '页面属性',
    mhInstanceConfigSource: '同步数据源',
    mhInstanceConfigTask: '同步任务'
  },
  login: {
    selectTenant: '选择租户',
    accountSettings: '账号设置',
    basicInformation: '基础资料',
    name: '名称',
    address: '地址',
    logout: '退出',
    scanLogin: '扫码登录',
    scanSuccess: '扫码成功',
    welcomeLogin: '欢迎登录 Tracking System',
    expired: '二维码已过期，请',
    refresh: '刷新',
    login: '登录',
    openMiniProgram: '打开Tracking看数小程序，扫一扫登录'
  },
  navbar: {
    changeTenant: '切换租户',
    accountSetting: '帐号设置',
    logOut: '退出',
    welcome: '欢迎，'
  },
  public: {
    default: '默认',
    choice: '更多',
    copy: '复制',
    test: '测试',
    queryTime: '查询时间',
    pleaseChoose: '请选择',
    timeInterval: '请选择监控时段',
    time: '时间',
    loading: '加载中...',
    confirm: '确定',
    submit: '提交',
    detail: '详情',
    delete: '删除',
    new: '新增',
    assign: '分配',
    share: '分享',
    update: '更新',
    online: '上线时间',
    edit: '编辑',
    editMhId: 'MH身份标识',
    behavior: '行为轨迹',
    noData: '暂无数据',
    confirmDel: '确认删除？',
    prompt: '提示',
    successDel: '删除成功',
    successLink: '数据源链接成功。',
    failDel: '删除失败',
    successAdd: '添加成功',
    successSetting: '设置成功',
    startDate: '开始日期',
    endDate: '结束日期',
    startDateTime: '开始日期时间',
    endDateTime: '结束日期时间',
    to: '至',
    today: '今天',
    lastWeek: '最近一周',
    lastMonth: '最近一个月',
    lastThreeMonth: '最近三个月',
    small: '小',
    medium: '中',
    large: '大',
    type: '类型',
    yes: '是',
    no: '否',
    query: '查询',
    export: '导出',
    exportCsv: '导出为csv文件',
    clearFilter: '重置',
    save: '保存',
    cancel: '取消',
    callback: '返回',
    second: '秒',
    minute: '分钟',
    hour: '小时',
    connector1: '不为空',
    connector2: '为空',
    connector3: '不等于',
    connector4: '等于',
    connector5: '大于',
    connector6: '小于',
    connector7: '左包含',
    connector8: '有值',
    connector9: '没值',
    connector10: '区间',
    connector11: '大于等于',
    connector12: '小于等于',
    connector13: '为真',
    connector14: '为假',
    connector15: '包含',
    connector16: '右包含',
    connector17: '不包含',
    by: '按',
    is: '为',
    of: '的',
    remark: '备注',
    import: '导入',
    disable: '停用',
    enable: '启用',
    normal: '正常',
    selectDate: '选择日期',
    add: '添加',
    string: '字符串',
    number: '数值',
    view: '查看',
    batchImport: '批量导入',
    uploadFile: '上传文件',
    templateDownload: '模板下载',
    file: '文件',
    template: '模板',
    allTimes: 'PV（访问人数）',
    distribute: '分布',
    stayTime: '停留时长',
    stayTimeAll: '停留时长的总和',
    sum: '总和',
    average: '均值',
    max: '最大值',
    min: '最小值',
    times: '次',
    day: '天',
    timesNumber: '次数',
    dayNumber: '天数',
    visitTimes: 'PV(访问量)',
    hourNumber: '小时数',
    deduplication: '去重数',
    pcs: '个',
    peopleAvg: '人均值',
    days: '日',
    weeks: '周',
    months: '月',
    onMonday: '周一',
    tuesday: '周二',
    wednesday: '周三',
    thursday: '周四',
    friday: '周五',
    saturday: '周六',
    sunday: '周日',
    recover: '恢复',
    successRecover: '恢复成功',
    failRecover: '恢复失败',
    successReclaim: '成功回收',
    failReclaim: '回收失败',
    platform: '租户',
    systemUser: '用户',
    chineseEnglish: '语言',
    lastPage: '上一页',
    nextPage: '下一页',
    establish: '创建',
    accountLogin: '账号登录',
    updateTheCurrentTag: '更新当前标签',
    addToOverview: '添加到概览',
    saveAsANewLabel: '保存为新标签',
    saveAsLabel: '保存为标签',
    myBookmark: '我的书签',
    OverviewTip: '我的概览仅支持本人查看，可以分享给其他人查看，同时会生成一个当前查询条件的书签保存在书签列表中',
    myBookmarkTip: '我的书签可以在书签页面查看,支持添加到我的书签中',
    scanCodeLogin: '扫码登录',
    EnterTenantName: '请输入租户名称',
    domainNameWhitelin: '域名白名单',
    archived: '已归档',
    unArchived: '未归档',
    filed: '归档',
    Filed: '归档'
  },
  message: {
    m1: '该书签已被概览使用中，不可删除',
    m2: '已取消',
    m3: '没有查到数据',
    m4: '请尝试调整时间段或筛选条件',
    m5: '请完整填写信息!',
    m6: '请选择条件',
    m7: '请选择连接符',
    m8: '请选择值',
    m9: '未选择分组',
    m10: '未选择指标',
    m11: '请选择属性',
    m12: '未选择事件',
    m13: '请输入分群名称',
    m14: '请输入值',
    m15: '请输入整数',
    m16: '输入漏斗名称',
    m17: '未选择周期',
    m18: '未选择漏斗步骤事件',
    m19: '漏斗步骤必须有两步及以上',
    m20: '还未选择项目，不能新建分组！',
    m21: '是否删除该活动?',
    m22: '是否删除？',
    m23: '删除漏斗将会删除与该漏斗相关的书签与概览组件，是否删除漏斗?',
    m24: '是否申请上线?',
    m25: '是否通过上线申请?',
    m26: '是否取消上线申请?',
    m27: '是否删除该数据?',
    m28: '是否删除该链接?',
    m29: '是否删除该渠道?',
    m30: '此操作将永久删除该属性, 是否继续?',
    m31: '是否删除自定义事件?',
    m32: '是否删除该属性?',
    m33: '确定要删除此事件分组吗？是否继续？',
    m34: '确定要删除此菜单吗？是否继续？',
    m35: '确定要删除此角色吗？是否继续？',
    m36: '还未选择项目，不能添加活动！',
    m37: '新增成功',
    m38: '编辑成功',
    m39: '尚未进行任何数据分析',
    m40: '请仔细检查区间规范：左区间值不能大于右区间值!',
    m41: '请完整填写设置分组信息!',
    m42: '天数范围不能大于7天',
    m43: '创建漏斗成功！',
    m44: '编辑漏斗成功！',
    m45: '天数范围大于3天，只能选择按天',
    m46: '成功指定UV统计字段！',
    m47: '申请成功',
    m48: '成功通过申请',
    m49: '还未选择项目，不能添加渠道！',
    m50: '成功添加渠道',
    m51: '成功修改渠道',
    m52: '还未选择所属应用',
    m53: '只支持单文件上传',
    m54: '渠道文件导入成功',
    m55: '导入失败！！',
    m56: '还未选择项目，不能添加渠道规则！',
    m57: '修改成功！',
    m58: '还未选择项目，不能添加链接！',
    m59: '请选择触发的时间范围',
    m60: '请选择需要分组的事件！',
    m61: '分组成功',
    m62: '还未选择项目，不能新建事件！',
    m63: '请选择需要删除的事件！',
    m64: '未选择应用',
    m65: '还未选择项目，不能新增概览！',
    m66: '还未选择项目，不能添加属性',
    m67: '授权成功',
    m68: '信息修改成功！',
    m69: '请正确填写信息！',
    m70: '成功指定项目负责人！',
    m71: '当前项目数据正在使用，请选择其他项目！',
    m72: '两次密码输入不一致',
    m73: '密码修改成功',
    m74: '还未选择项目，不能添加短链！',
    m75: '短链文件导入成功',
    m76: '密码重置成功',
    m77: '取消成功！',
    m78: '更新成功',
    m79: '请选择事件属性',
    m80: '未选择起始行为',
    m81: '未选择后续行为',
    m82: '请选择事件',
    m83: '请选择分组',
    m84: '最少选择一个参与分析的事件',
    m85: '未选择落地页',
    m86: '请选择指标',
    m87: '请输入大于0的整数',
    m88: '请输入内容',
    m89: '不能为空',
    m90: '请输入预警名称',
    m91: '请选择预警的事件',
    m92: '请选择应用',
    m93: '未选择所属概览',
    m94: '请填写组件名称',
    m95: '请输入活动名称,不超过48个字符',
    m96: '未选择计算结果',
    m97: '请输入指标名称',
    m98: '未输入',
    m99: '请选择所属应用',
    m100: '未输入文章标题',
    m101: '未输入链接',
    m102: '未输入带监测的短链',
    m103: '未选择分析的漏斗',
    m104: '请选择应用所属租户',
    m105: '请选择所属项目',
    m106: '请输入应用名称',
    m107: '请选择所属应用平台',
    m108: '请选择应用状态',
    m109: '未选择所属应用',
    m110: '未选择查询的时间范围',
    m111: '未输入大类渠道',
    m112: '未输入小类渠道',
    m113: '未输入渠道标识',
    m114: '未输入渠道名称',
    m115: '未输入链接投放地址',
    m116: '未输入链接落地页地址',
    m117: '未输入渠道所在位置',
    m118: '请输入规则前缀匹配',
    m119: '请输入规则替换内容',
    m120: '请输入链接名称,不超过16个字符',
    m121: '请输入推广地址，不超过120字符',
    m122: '请输入广告系列来源,不超过30个字符',
    m123: '请输入广告系列媒介,不超过30个字符',
    m124: '请输入广告系列内容,不超过200个字符',
    m125: '请输入广告系列名称,不超过16个字符',
    m126: '请输入广告关键字,不超过16字符',
    m127: '请输入渠道名称,不超过16个字符',
    m128: '请输入标识，不超过16字符',
    m129: '请选择事件所属应用平台',
    m130: '未输入事件名称',
    m131: '请选择事件所属应用平台',
    m132: '请输入名称',
    m133: '请选择分享类型',
    m134: '分组名称不能为空',
    m135: '请输入属性ID',
    m136: '请输入属性名称',
    m137: '请选择数据类型',
    m138: '请选择数据属性',
    m139: '事件ID不能为空',
    m140: '事件名称不能为空',
    m141: '菜单名称不能为空',
    m142: '菜单编码不能为空',
    m143: '菜单路径不能为空',
    m144: 'path 格式只支持英文、"_"、"/" 组合',
    m145: '请输入项目名称',
    m146: '请输入项目类型',
    m147: '请选择项目状态',
    m148: '未输入角色名称',
    m149: '角色编码不能为空',
    m150: '角色编码格式只支持英文、数字、下划线',
    m151: '姓名不能为空',
    m152: 'Email地址不能为空',
    m153: '请输入正确的邮箱地址',
    m154: '请输入正确的手机号码',
    m155: '请输入组织Key',
    m156: '请输入组织密钥',
    m157: '旧密码不能为空',
    m158: '新密码不能为空',
    m159: '请再次输入新密码',
    m160: '用户名不能为空',
    m161: '未输入用户的密码',
    m162: '密码格式只支持英文、数字、下划线',
    m163: '密码长度只能在6-30之间',
    m164: '请输入组织名称',
    m165: '请输入组织地址',
    m166: '未选择用户类型',
    m167: '所属应用不能为空',
    m168: '事件名称不能为空',
    m169: '只能输入数字类型',
    m170: '请输入',
    m171: '请输入关键字',
    m172: '请选择应用',
    m173: '所有分组',
    m174: '请添加属性',
    m175: '文件只能上传下载的模板格式',
    m176: '请下载最新模板',
    m177: '请输入订阅人邮箱号码，多个邮箱号码之间用 “,” 分割',
    m178: '请选择组织',
    m179: '请选择角色',
    m180: '请选择目标转化事件',
    m181: '请选择待归因事件',
    m182: '请先输入密码哦',
    m183: '恭喜您，密码复制成功！',
    m184: '删除session将会删除与该session相关的书签与概览组件，是否删除?',
    m185: '未选择 Session',
    m186: '恭喜您，创建成功啦！',
    m187: '恭喜您，更新成功啦！',
    mInput: '请输入...',
    user: '请输入身份标识',
    textguid: '请输入身份标识id',
    mSel: '请选择...',
    m188: '该同步数据源已有同步任务，不可删除。',
    m199: '移至回收站成功',
    m200: '请选择需要恢复的事件',
    m201: '请选择需要移至回收站的事件',
    m202: '是否恢复自定义事件',
    m203: '是否移至回收站',
    m204: '是否删除该用户分群',
    m205: '确定上线?',
    m206: '上线成功',
    m207: '该同步数据源已有同步任务，不可删除。',
    m208: '文件路径不能为空',
    m209: '前向关联事件：一般为介于“待归因事件”与“目标转化事件”之间的纽带事件，如商品详情、加入购物车等与商品曝光相关的事件；',
    m210: '在归因分析中作为归因的辅助曝光点参与计算，提升归因模型的计算精度。',
    m211: '请选择应用上线时间。',
    m212: '请选择行为',
    m213: '请先配置应用哦',
    m214: '请选择要解绑的小程序',
    m215: '请选择排列在哪个属性的后面',
    m216: '请选择待归因渠道',
    m257: '请勾选直接转化参与归因计算',
    m258: '营收行为最多只能添加10个',
    m259: '筛选条件最多只能添加10个',
    m260: '筛选条件只能添加1个',
    m261: '请输入数据源名称',
    m262: '请输入用户名称',
    m263: '请输入数据源地址',
    m264: '请选择类型',
    m265: '相同事件的的事件属性不能重复选择',
    m266: '参与分析的事件重复',
    m267: '根据开始时间和结束时间按周拆分，拆分出每周的数据在开始时间和结束时间范围内进行统计',
    m268: '根据开始时间和结束时间按月拆分，拆分出每月的数据在开始时间和结束时间范围内进行统计',
    m269: '请输入任务名称',
    m270: '请输入数据源',
    m271: '请输入目标表',
    m272: '请选择数据类型',
    m273: '请选择同步频率',
    m274: '名称不能为空',
    m275: '事件不能为空',
    m276: '切割规则时间值不能为空',
    m277: '切割规则时间类型不能为空',
    m278: '是否删除虚拟事件?',
    m279: '确定要删除此页面属性吗？是否继续？',
    m280: '确定要停用此租户吗？是否继续？',
    m281: '确定要删除此数据源吗？是否继续？',
    m282: '确定要删除该任务吗？是否继续？',
    m283: '指标定义不合法，请修改',
    m284: '域名请用 ”, “隔开',
    m285: '请输入session分割时间',
    m286: '数值最小为1',
    m287: '单位为分钟数值最大为525600',
    m288: '单位为小时数值最大为8760',
    m299: '检测该应用30天内采集到行为数据，是否进行归档？（归档后不再采集数据，且归档操作不可逆）',
    m300: '是否进行归档？（归档后不再采集数据，且归档操作不可逆）',
    m301: '操作成功'
  },
  tooltip: {
    t1: '提示选项为最近七天的属性关键词<br>(最多展示30条)，非所有关键词。<br>可直接输入关键词，回车完成。',
    t2: '如果没有点击事件，请到<br>「埋点 - 自定事件」进行<br>同步！',
    t3: '提示选项为当天的属性关键词，<br>非当天的关键词。<br>可直接输入关键词，回车完成。',
    t4: '下降',
    t5: '上升',
    t6: '对比',
    t7: '一般为产品的支付、成单等收益相关的事件。',
    t8: '一般为广告的点击、运营位的点击等运营相关的事件。',
    t9: '若一个“目标转化事件”在转化前，没有发生<br>任何相关的“待归因事件”，则认为该“目标<br>转化事件”属于直接转化。',
    t10: '第一天进行了web浏览页面，第二天也进行了<br>web浏览页面的用户，且在所选起始时间前180天<br>内未出现的用户(新用户)的次日留存的平均值。',
    t11: '跳出指用户在一次访问中仅做了一次互动便选择了离开。<br />计算公式：该网页是会话中“唯一网页”的会话占由该网页开始的<br />所有会话的百分比。跳出率越高就说明该网站对访问者的吸引力越低，<br />当跳出率达到一定的程度时，就说明网站需要做些优化或者页面更新了。',
    t12: '指该网页是会话中“最后一页”的浏览占该网页总浏览量的百分比。<br /> 首页综合浏览量是1000次，从这个页面离开本站的次数是40次，<br /> 则首页的退出率是 4%。跳出率高，说明很多新用户来了，<br />看了一页就离开退出率低，说明新老用户来了都点击很多页才离开',
    t13: '收藏项目，将提升项目在顶端下拉列表项目排序',
    t14: '指开始计算后的有效时间范围，超过有效时间范围则结束计算',
    t15: '页面名称',
    t16: '页面完整带参地址，一个页面支持多个带参地址访问',
    t17: '页面访问路径（不支持带参），一个路径对应一个页面',
    t18: '满足第一个触点占100%转化功劳',
    t19: '满足最后一个触点占100%转化功劳',
    t20: '满足条件的触点平均分配转化功劳',
    t21: '根据设置的功劳比例，计算每个触点的功劳占比，首次40%，中间20%，末尾40%',
    t22: '根据设置的功劳比例，计算每个触点的功劳占比，首次40%，中间20%，末尾40%',
    t23: '首次触点归因：多个「待归因事件」对同一个「目标转化事件」作出贡献时，认为第一个「待归因事件」功劳为 100% <br /> 末点触点归因：多个「待归因事件」对同一个「目标转化事件」作出贡献时，认为最后一个「待归因事件」功劳为 100% 。<br /> 线性归因：多个「待归因事件」对同一个「目标转化事件」作出贡献时，认为每个「待归因事件」平均分配此次功劳。<br /> 位置归因：多个「待归因事件」对同一个「目标转化事件」作出贡献时，认为第一个和最后一个「待归因事件」各占 40% 功劳，其余「待归因事件」平分剩余的 20% 功劳。<br /> 时间衰减归因：多个「待归因事件」对同一个「目标转化事件」作出贡献时，认为越靠近「目标转化事件」做出的贡献越大。',
    t24: '指所选时间范围内，在过去半年内未出现过的用户',
    t25: '新用户唯一身份访客浏览人数。新用户定义：指所选时间范围内，在过去半年内未出现过的用户',
    t26: '所有会话的总次数，即分析Session内具体事件时，可以计算Session内事件发生次数',
    t27: '计算该时间点同时存在的会话数。我们认为一个会话是一个持续的时段，该时间点有多少个会话同时在线即为同时并发人数',
    t28: '计算公式：Seesion总次数/唯一身份访客数量',
    t29: '停留时长'
  },
  overview: {
    applicationKey: '应用',
    initialbehavior: '初始行为',
    today: '今日',
    yesterday: '昨日',
    recentSevenDays: '最近7天',
    recentThirtyDays: '最近30天',
    baseIndicator: '基础指标',
    pvuvTrend: 'PV&UV趋势',
    channelTable: '渠道 PV/UV/人均访问量',
    pageTable: '页面 PV/UV/人均访问量',
    eventTable: '事件点击情况',
    sceneTable: '场景值 PV/UV/人均访问量',
    channelName: '渠道',
    pageName: '页面名称',
    eventName: '事件名称',
    scene: '场景值',
    visitor: '人均访问量',
    StandingTime: '人均停留时长',
    operation: '操作',
    trendDetail: '趋势详情',
    clickNumber: '点击次数',
    clickPeople: '点击人数',
    chainRatio: '环比',
    chainRatioMean: '指对比昨天',
    yoy: '同比',
    yoyMean: '指对比上周同一天',
    pv: '总 PV',
    uv: '总 UV',
    oldUser: '累计老用户数',
    newUser: '新增用户数',
    avgUser: '人均访问量',
    avgTime: '人均停留时长',
    deviceId: '设备ID数',
    mineOverview: '我的概览',
    shareOverview: '分享给我的概览',
    overview: '概览',
    overviewName: '概览名称',
    createTime: '创建时间',
    newOverview: '新建概览',
    creator: '创建人',
    shareOverviewTitle: '分享概览',
    shareType: '分享类型',
    userName: '用户名',
    name: '姓名',
    specifyMember: '指定成员可见',
    allMember: '项目下所有成员可见',
    analysisType: '选择分析类型',
    overallDesc: '分析用户整体行为',
    eventDesc: '通过条件筛选、分组和聚合能力，多维分析用户行为',
    pageDesc: '分析page_url/page_name/current_path 的PV、UV、平均停留时间、跳出率、IP数等指标',
    funnelDesc: '分析一个多步骤过程中每一步的转化和流失情况',
    retainedDesc: '分析用户参与情况和活跃程度',
    customDesc: '基础指标之间的四则运算，可灵活定义符合业务场景的特有指标',
    landingDesc: '落地页投放的各个渠道来源监测',
    distributionDesc: '查看事件不同指标的用户分布情况',
    attributionDesc: '监听产品下的广告位、推广位等关键事件对目标事件的转化贡献',
    sessionDesc: '对用户的这一系列行为互动进行深入洞察',
    channelDesc: '对接入的渠道进行指标对比，来更清晰的辨别渠道的优略情况',
    intervalDesc: '计算用户行为序列中两个事件的时间间隔，得到业务转化环节的转化时长分布',
    fromBookmark: '从书签中添加',
    newComponent: '添加组件',
    noComponent: '未添加组件',
    noBookmark: '暂无书签',
    firstSaveBookmark: '先将分析模型保存为书签',
    bookmark: '书签',
    whichOverview: '所属概览',
    bookmarkName: '书签名称',
    unknown: '未知',
    useOverviewNumber: '使用概览个数',
    isDynamicShow: '是否动态时间窗口展示',
    whichApplication: '所属应用',
    newUserQuestion: '指所选时间范围内，在过去半年内未出现过的用户',
    oldUserQuestion: '指所选时间范围内，在过去半年内曾经出现过的用户',
    deviceIdQuestion: '设备ID是 Tracking SDK 自动生成的，是一种匿名ID。<br/>假如产品可能没有用户体系，可以选择设备ID 作为用户标识',
    chooseABookmark: '选择书签',
    modifyOverviewName: '修改概览名称'
  },
  analysis: {
    querying: '查询中...',
    queue: '查询正在队列，等待中,当前排在第',
    ltvDay: 'ltv当天',
    LTVDay: 'LTV当天',
    initPerson: '初始人数',
    indicator: '指标',
    group: '分组',
    revenuebehavior: '营收行为',
    filterCondition: '筛选条件',
    relation: '设置前向关联事件',
    addRelation: '添加前向关联事件',
    byDay: '按天',
    byHour: '按小时',
    byWeek: '按周',
    byMonth: '按月',
    trendChart: '趋势图',
    summaryChart: '汇总图',
    tableDiagram: '表格图',
    numericalGraph: '数值图',
    comparisonChart: '对比图',
    boxChart: '箱型图',
    total: '合计',
    average: '均值',
    display: '显示',
    saveToOverview: '保存到概览',
    chartType: '图表类型',
    event: '事件',
    condition: '条件',
    connector: '连接符',
    selectFunnel: '选择漏斗',
    funnel: '漏斗',
    pleaseFunnel: '请选择漏斗',
    windowPeriod: '窗口期',
    funnelName: '漏斗名称',
    funnelWindow: '漏斗窗口期',
    attributionWindow: '归因窗口期',
    funnelStep: '漏斗步骤',
    step: '步骤',
    addStep: '添加步骤',
    triggerCondition: '触发条件',
    newFunnel: '创建漏斗',
    editFunnel: '编辑漏斗',
    initialBehavior: '初始行为',
    followBehavior: '后续行为',
    behavior: '行为',
    value: '值',
    eventAttributes: '事件属性',
    joinEvent: '参与分析的事件',
    setSession: '设置Session间隔',
    beginEvent: '起始事件',
    endEvent: '结束事件',
    userFor: '用户进行',
    landingPage: '落地页',
    conversionGoal: '转化目标',
    newIndicator: '新增指标',
    editIndicator: '编辑指标',
    definedIndicator: '定义指标',
    addIndicator: '新指标',
    cancelCompare: '取消对比',
    editCustom: '编辑自定义分析',
    addCustom: '添加自定义分析',
    indicatorName: '指标名称',
    result: '计算结果',
    origin: '原始数据',
    fixedTwo: '保留两位小数',
    keepInterger: '保留整数',
    multipliedBy: '乘于100%',
    noData: '无匹配数据',
    overview: '整体',
    integer: '整数',
    metaEvent: '元事件',
    clickEvent: '点击事件',
    componentName: '组件名称',
    belongOverview: '所属概览',
    addOverview: '添加整体分析',
    editOverview: '编辑整体分析',
    addEvent: '添加事件分析',
    editEvent: '编辑事件分析',
    editLtv: '添加LTV分析',
    addditLtv: '编辑LTV分析',
    addPage: '添加页面分析',
    editPage: '编辑页面分析',
    addChannel: '添加渠道分析',
    editChannel: '编辑渠道分析',
    addSession: '添加 session 分析',
    editSession: '编辑 session 分析',
    addFunnel: '添加漏斗分析',
    addRetained: '添加留存分析',
    editRetained: '编辑留存分析',
    addIntervalAnalyse: '添加间隔分析',
    editIntervalAnalyse: '编辑间隔分析',
    addLanding: '添加落地页分析',
    editLanding: '编辑落地页分析',
    addDistribute: '添加分布分析',
    editDistribute: '编辑分布分析',
    addMember: '添加人员',
    editMember: '编辑人员',
    channelSource: '渠道来源',
    pageview: '访问量',
    pageviewPV: '访问量',
    visitUV: '访客数',
    vistors: '访客数',
    transform: '目标转化',
    historyTrend: '页面详情',
    page: '页面',
    bounceRate: '跳出率',
    exitRate: '退出率',
    ipNumber: 'IP数',
    pvNumber: 'PV(访问量)',
    pv: 'PV',
    uv: 'UV',
    uvNumber: 'UV(访客数)',
    averageTime: '人均停留时长(s)',
    granularity: '粒度',
    viewUserDetail: '查看用户明细',
    userDetail: '用户明细',
    withinDay: '一天内',
    withinWeek: '一周内',
    withinMonth: '一月内',
    howGroup: '设置如何分组',
    interval: '区间',
    addInterval: '增加区间',
    dayRemain: '日留存',
    weekRemain: '周留存',
    monthRemain: '月留存',
    targetEvent: '目标转化事件',
    attributionEvent: '待归因事件',
    analysisModel: '分析模型',
    firstAttribution: '首次触点归因',
    lastAttribution: '末次触点归因',
    linearAttribution: '线性归因',
    locationAttribution: '位置归因',
    timeAttribution: '时间衰减归因',
    directAttribution: '直接转化参与归因计算',
    deviceID: '设备ID',
    sessionsInteger: '会话数(Session)',
    avgDeep: '页面平均访问深度',
    groupBy: '分组为',
    all: '总',
    avgUseTime: '平均使用时长(s)',
    overall: '总体的',
    totalTimes: 'PV(访问量)',
    userNumber: 'UV(访客数)',
    totalTime: '访问量',
    userNumbers: '访客数',
    eventOverview: '事件概览',
    eventOverviewAnalysis: '事件概览分析',
    pageAddr: '页面地址',
    pageName: '页面名称',
    pagePath: '页面路径',
    totalRate: '总转化率',
    conversionFunnel: '转化漏斗',
    fiveMinutes: '五分钟',
    oneHour: '1小时',
    twentyfourHour: '24小时',
    sevenDays: '7天',
    fourteenDays: '14天',
    thirtyDays: '30天',
    sixtyDays: '60天',
    defaultAttr: '默认属性',
    eventAttr: '事件属性',
    pageAttr: '页面属性',
    entire: '总体',
    overallConversion: '总体转化',
    displayGroup: '显示分组',
    displayIndicator: '显示指标',
    people: '人',
    totalPeople: '总人数',
    date: '日期',
    sessionsNumber: '会话数',
    day: '天',
    hour: '小时',
    minute: '分钟',
    sessionPv: 'Session 总次数',
    sessionUv: 'Session 同时并发人数',
    sessionAvg: '人均 Session 次数',
    sessionRate: '跳出率',
    sessionTime: '停留时长(s)',
    transformationEvent: '转化事件',
    webChannel: '渠道',
    name: '名称',
    userScale: '用户规模',
    userQuality: '用户质量',
    userTarget: '新用户目标转化事件',
    channelPv: '渠道访问次数',
    channelUv: '渠道访问量',
    channelNewPv: '新用户访问量',
    channelNewUv: '新用户访客数',
    newPv: '新用户访问次数',
    newUv: '新用户访用户数',
    newRate: '新用户次日留存',
    middleInterval: '间隔时间中位数',
    maxInterval: '最大值',
    minInterval: '最小值',
    q1Interval: '上四分位',
    q3Interval: '下四分位',
    avgInterval: '平均转化时间',
    attributionChannel: '待归因渠道',
    contact: '触点',
    channel: '渠道',
    clickScale: '点击规模',
    totalClick: '总点击数',
    clickEffective: '有效转化点击率',
    goalConversion: '目标转化',
    contribution: '贡献度',
    identity: '身份标识',
    time: '时间',
    trendTitle: '趋势概况',
    channelTitle: '渠道来源',
    siteTitle: '站内流量(上一个页面来源)',
    pageTitle: '页面详情',
    attributionType: '待归因类型',
    synchronization: '同步事件',
    indexElement: '指标元素',
    operator: '运算符',
    brackets: '括号',
    newsession: '创建 Session',
    editsession: '编辑 Session',
    sessionName: 'Session 名',
    sessionEvent: 'Session 包含的事件',
    cuttingRules: '切割规则',
    sessionTip: '建议 Web 产品建议切割时间为 30 分钟，APP 产品建议切割时间为 1 分钟',
    globalfiltering: '全局筛选',
    numberOfViewers: '浏览人数',
    proportion: '占比',
    funnyInformation: '漏斗信息',
    fullySettings: '漏斗步骤设置'
  },
  group: {
    people: '人数',
    newGroupRule: '创建分群规则',
    editGroupRule: '编辑分群规则',
    setBase: '设置基础信息',
    groupName: '分群名',
    remark: '备注',
    configRule: '配置分组规则',
    behavior: '行为',
    addFilter: '添加筛选',
    groupDetail: '分群的用户明细',
    unUpdated: '未更新',
    do: '做过',
    undo: '未做过',
    dayNumber: '天数',
    userBehavior: '用户行为满足',
    bebaviorSeq: '行为序列',
    or: '或',
    and: '且',
    andFulfil: '并且满足',
    didItInTurn: '依次做过',
    delBehavior: '删除行为',
    delEvent: '删除事件',
    delCondition: '删除条件',
    applicationName: '应用名称',
    name: '名称',
    platform: '平台',
    deviceVersion: '设备版本',
    networkType: '网络类型',
    operator: '运营商',
    systemLanguage: '系统语言',
    sourceChannel: '来源渠道(business_channel)',
    province: '省',
    city: '市',
    resolution: '屏幕分辨率(高*宽)',
    deviceBrand: '设备品牌',
    deviceModel: '设备型号',
    accessPath: '访问路径',
    pageParameter: '页面参数',
    eventParameter: '事件参数',
    page: '页面',
    event: '事件',
    at: '于',
    beApplied: '在应用',
    clickEvent: '点击事件',
    browsePage: '浏览页面'
  },
  channel: {
    name: '名称搜索',
    linkNumber: '链接数量',
    activityName: '活动名称',
    linkName: '链接名称',
    adSource: '广告系列来源',
    adMedia: '广告系列媒介',
    adContent: '广告系列内容',
    adName: '广告系列名称',
    adKey: '广告系列关键字',
    channelKey: '渠道标识',
    channelName: '渠道名称',
    bigChannel: '大类渠道',
    smallChannel: '小类渠道',
    putLink: '投放链接',
    landingPosi: '落地页位置',
    channelPosi: '渠道所在位置',
    channelDepartment: '渠道所属部门',
    remarkContent: '备注内容',
    rulePre: '规则前缀',
    ruleChannel: '规则渠道',
    status: '状态',
    articalTitle: '文章标题',
    link: '链接',
    linkDetail: '链接详情',
    promoteAttr: 'UTM推广地址',
    trend: '趋势',
    table: '表格',
    shortLink: '带监测的短链',
    clickNumber: '点击量',
    newActivity: '添加活动',
    editActivity: '编辑活动',
    newLink: '添加链接',
    editLink: '编辑链接',
    channel: '渠道',
    newChannel: '添加渠道',
    editChannel: '编辑渠道',
    channelRule: '渠道规则',
    newChannelRule: '添加渠道规则',
    editChannelRule: '编辑渠道规则',
    newShortChain: '添加短链',
    editShortChain: '编辑短链',
    shortChain: '短链',
    belongActivity: '所属活动',
    belongChannel: '所属渠道',
    promoteAddr: '推广地址'
  },
  buriedPoint: {
    log: '日志',
    groupName: '分组名称',
    containEvent: '包含事件',
    desc: '描述',
    eventID: '事件ID',
    attrId: '属性ID',
    dataType: '数据类型',
    visible: '可见性',
    dataAttr: '数据属性',
    group: '分组',
    addEventGroup: '创建事件分组',
    editEventGroup: '编辑事件分组',
    syncTime: '同步时间',
    baseInformation: '基本信息',
    eventDesc: '事件说明',
    moveGroup: '移至分组',
    moveReclaim: '移至回收站',
    customAttr: '自定义属性',
    index: '序号',
    attrType: '属性类型',
    attr: '属性',
    pageAttribute: '页面属性',
    recentlyEdited: '最近修改人',
    lastUpdateTime: '最近修改时间',
    eventParam: '事件参数',
    recordTime: '记录时间',
    triggerRecord: '触发记录',
    addEvent: '添加事件',
    editEvent: '编辑事件',
    virtualEvent: '虚拟事件的组成',
    attrName: '属性名称',
    anotherName: '别名',
    belongAttr: '所属属性',
    presetAttr: '预置属性',
    publicAttr: '公共属性',
    sessionAttr: '会话属性',
    pageAttr: '页面属性',
    eventAttr: '事件属性',
    userAttr: '用户属性',
    defaultAttr: '默认属性',
    addAttr: '添加属性',
    editAttr: '编辑属性',
    addPageAttr: '新增页面属性',
    editPageAttr: '编辑页面属性',
    syncing: '同步中....',
    loading: '加载中....',
    selApp: '请选择需要导出事件列表的的应用:',
    exportEvents: '导出事件列表',
    attributesSize: '事件属性个数',
    synchronization: '同步事件'
  },
  menu: {
    addColumn: '添加根目录菜单',
    name: '菜单名称',
    enName: '英文名称',
    code: '菜单编码',
    route: '菜单路径',
    symbol: '菜单图标',
    order: '菜单排序',
    visible: '是否可见',
    addSub: '添加子菜单',
    bindMenu: '绑定按钮菜单',
    upperMenu: '上级菜单',
    rootDirectory: '根目录',
    type: '类型',
    buttonName: '按钮名称',
    authorityName: '权限名称',
    authorityCode: '权限编码',
    authorityType: '权限类型',
    button: '按钮',
    hasSelect: '已选内容',
    piece: '条',
    pageButton: '页面-按钮权限管理',
    addMenu: '添加菜单',
    editMenu: '编辑菜单'
  },
  setting: {
    monitoringperiod: '监控时段',
    projectName: '项目名称',
    projectType: '项目类型',
    projectStatus: '项目状态',
    projectLeader: '项目负责人',
    projectDeline: '项目期限',
    appName: '应用名称',
    appPlatform: '应用平台',
    appUtc: '应用时区',
    appStatus: '应用状态',
    belongProject: '所属项目',
    belongTenant: '所属租户',
    name: '姓名',
    userName: '用户名',
    email: '邮箱',
    belongRole: '所属角色',
    roleName: '角色名称',
    roleCode: '角色编码',
    signKey: '签名Key',
    signSecret: '签名密钥',
    desc: '描述',
    projectNumber: '授权项目数',
    addRole: '添加角色',
    roleDetail: '角色详情',
    editRole: '编辑角色',
    menuPermission: '菜单权限',
    organizationInformation: '组织信息',
    addSign: '添加签名',
    editSign: '编辑签名',
    sign: '签名',
    authorizeItem: '授权项目',
    generateKey: '生成KEY',
    generateSecret: '生成密钥',
    selectProject: '请选择项目',
    authorized: '已授权',
    unauthorized: '未授权',
    phone: '手机号码',
    userMessage: '用户信息',
    projectInformation: '项目设置',
    personalProject: '个人项目',
    loginRecord: '登录记录',
    displayInList: '是否显示在顶部项目列表',
    loginTime: '登录时间',
    loginIp: '登录IP',
    loginSource: '登录来源',
    changePassword: '修改密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    loginInformation: '登录信息',
    city: '城市',
    nickname: '昵称',
    age: '年龄',
    warning: '预警',
    addWarning: '创建预警',
    editWarning: '编辑预警',
    frequence: '频率',
    threshold: '阈值',
    compareTo: '比',
    high: '高',
    low: '低',
    percent: '百分比',
    bookMember: '订阅人员',
    bookEmail: '订阅邮箱',
    creatAndUse: '创建并启用',
    warningManage: '预警管理',
    warningName: '预警名称',
    heading: '名称',
    everyDay: '每天',
    perHour: '每小时',
    open: '开通',
    pvNumber: '访问量(PV)',
    uvNumber: '访客数(UV)',
    fixedValue: '固定值',
    sameLastWeek: '上周同一天',
    averageLastSeven: '前七天均值',
    lastHour: '上一个小时',
    inflowTime: '最新数据流入时间',
    yesterdayHour: '昨天同一个小时',
    functionType: '功能类型',
    operationType: '操作类型',
    operationDate: '操作时间',
    operationUser: '操作用户',
    operationBehavior: '具体操作行为',
    roleAssign: '角色分配',
    fileStatus: '归档状态',
    from: '从',
    noCollectData: '到现在未采集到数据'
  },
  system: {
    sortAttrAfter: '排序',
    moveUp: '上移',
    moveDown: '下移',
    password: '密码',
    bindMenu: '绑定菜单',
    organizationName: '组织名称',
    organizationAddr: '组织地址',
    organizationStatus: '组织状态',
    menuName: '菜单名称',
    menuEnName: '英文名称',
    menuCode: '菜单编码',
    menuPath: '菜单路径',
    filePath: '文件路径',
    menuIcon: '菜单图标',
    menuSort: '菜单排序',
    userType: '用户类型',
    lite: '小程序',
    organization: '所属组织',
    uvWord: 'UV统计字段',
    clickhouseRows: 'clickhouse数量',
    sessionCutTime: 'session分割时间',
    cutTime: '分割时间',
    addSub: '添加子目录',
    addMain: '添加根目录',
    addApp: '添加应用',
    editApp: '编辑应用',
    addProject: '添加项目',
    editProject: '编辑项目',
    addUser: '添加用户',
    editUser: '编辑用户',
    addOrganization: '添加组织',
    editOrganization: '编辑组织',
    addMenu: '添加菜单',
    editMenu: '编辑菜单',
    parentMenu: '上级菜单',
    resetPassword: '重置密码',
    authorizeProject: '授权项目',
    unbindMiniProgram: '解绑小程序',
    open: '开放',
    testProject: '测试项目',
    tenant: '租户',
    multipleLogin: '多端登录',
    organizationRole: '所属组织角色',
    allow: '允许',
    notAllow: '不允许',
    tenantName: '租户名称',
    allSelect: '全选',
    reverseSelect: '反选',
    start: '启动',
    end: '停用',
    instanceName: '数据源名称',
    taskName: '任务名称',
    instanceType: '类型',
    tableName: '目标表',
    remark: '备注',
    basicInformation: '基础信息',
    databaseConfig: '数据库配置',
    tenantAppSyn: '租户-应用数据同步',
    tenantId: '租户ID',
    tenantState: '同步状态',
    tenantApp: '租户-应用',
    addTenant_App: '添加租户-应用',
    state: '状态',
    bindApp: '同步应用',
    bindFre: '同步频率',
    synTime: '上次同步时间',
    addTenantApp: '添加租户配置',
    addInstanceSource: '新增数据源',
    addInstanceTask: '新增任务',
    updateInstanceSource: '编辑数据源',
    updateInstanceTask: '编辑任务',
    mhInstanceSource: '数据源',
    sourceDetail: '数据源详情',
    mhInstanceTask: '任务',
    logType: '需同步数据类型',
    byDay: '按天',
    byHour: '按小时',
    task: '任务',
    taskList: '任务列表',
    inService: '运行中',
    unService: '未开启',
    dashboard: '系统概览',
    dataTrend: '数据趋势',
    n7DataTop10: '近7日-数据Top10',
    dataTop10: '数据Top10',
    dataDashboard: '数据概览',
    ranking: '排名',
    appName: '应用名称',
    dataSize: '数据量',
    tenantCount: '租户数',
    proCount: '项目数',
    appCount: '应用数',
    activeAppCount: '今日活跃应用数',
    total: '总日志行数',
    totalSize: '日志表数据大小',
    user: '总用户行数',
    numberOfUsers: '用户行数',
    numberOfLog: '日志行数',
    userSize: '用户表数据大小',
    session: '总session行数',
    page: '总pageview行数',
    event: '总event行数',
    visible: '是否可见'
  },
  form: {
    newOverviewWidth: '100px',
    newFunnelWidth: '105px',
    retainedWidth: '120px',
    userPathWidth: '150px',
    landingWidth: '120px',
    applicationWidth: '110px',
    attributionWidth: '120px',
    channelWidth: '120px',
    indicatorWidth: '120px',
    newLinkWidth: '120px',
    organizationWidth: '80px',
    projectQuerywidth: '80px',
    projectWidth: '80px',
    roleWidth: '80px',
    tenantWidth: '100px',
    signQueryWidth: '80px',
    eventQueryWidth: '80px',
    virtualQueryWidth: '80px',
    metaEventQueryWidth: '80px',
    promoteQueryWidth: '80px',
    shortChainWidth: '120px',
    tenantQueryWidth: '80px',
    addMhTenantAppFormLabelWidth: '100px',
    synSourceQueryWidth: '100px',
    overallAnalysis: '100px',
    eventAnalysis: '100px',
    funnelAnalysis: '120px',
    CreateSessionAnalysis: '150px',
    distributionAnalysis: '120px',
    sessionAnalysis: '100px',
    customIndicator: '100px',
    ltvAnalysis: '100px',
    personal: '100px',
    privilege: '80px',
    business_channel: '100px',
    user_form: '100px',
    business_channel_rule: '80px',
    page_attribute: '80px',
    event_group: '80px',
    meta_data_manage: '80px',
    meta_data: '80px',
    activity_manage: '80px',
    mh_instance_config: '120px',
    page: '100px',
    warning_form: '120px',
    changePassword_form: '80px',
    popover: '300px'
  }
}
